<template>
  <TwoColPageWrapper
    :menuItems="menuItems"
    :breadcrumbs="breadcrumbs"
    leftBanner
  >
    <router-view></router-view>
  </TwoColPageWrapper>
</template>

<script>
export default {
  data() {
    return {
      menuItems: [
        {
          to: "plants",
          name: "Заводы Sika в России",
        },
        {
          to: "innovations",
          name: "Инновации",
        },
        {
          to: "labs",
          name: "Лаборатории Sika в России",
        },
      ],
    };
  },
  computed: {
    breadcrumbs() {
      let out = [
        {
          label: "Главная",
          to: { name: "main" },
        },
      ];

      const routeName = this.$route.name;

      if (routeName === "about") {
        out.push({
          label: "О компании",
        });
        return out;
      } else {
        out.push({
          label: "О компании",
          to: { name: "about" }
        });
      }

      let lastLabel;
      if (routeName === "plants") {
        lastLabel = "Заводы Sika в России";
      } else if (routeName === "innovations") {
        lastLabel = "Инновации";
      } else if (routeName === "labs") {
        lastLabel = "Лаборатории Sika в России";
      }
      out.push({
        label: lastLabel,
      });
      return out;
    },
  },
};
</script>

<style lang="scss"></style>
